module.exports = __webpack_public_path__ + "static/media/benefits.f16ae3f9.png";